<template>
  <div class="myFeedback">
    <div class="list_box" v-show="list.length">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item"
        @click="
          $router.push({ path: '/feedbackDetails', query: { id: item.id } })
        "
      >
        <p>
          {{ item.feedbackContent }}
        </p>
        <div class="time">
          <span>{{ item.createTime }}</span>
          <span v-if="item.status === 1">已回复</span>
        </div>
      </div>
    </div>
    <div v-show="list.length === 0" class="nothing">
      <img src="@/assets/images/nothing.png" alt="" />
      <span>暂无数据</span>
    </div>
    <van-button type="primary" class="btn_sty" @click="feedback"
      ><van-icon name="plus" /> 反馈</van-button
    >
  </div>
</template>
<script>
import { getUserFeedbackInfo } from "@/api/Feedback";
export default {
  name: "MyFeedback",
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    async getList() {
      let { data } = await getUserFeedbackInfo();
      this.list = data;
    },
    feedback() {
      this.$router.push("/feedback");
    },
  },
};
</script>
<style lang="scss" scoped>
.myFeedback {
  background: #f5f6fa;
  min-height: calc(100vh - 46px);
  .list_box {
    padding: 10px 0 50px;
    .item {
      padding: 15px 15px 10px 15px;
      background-color: #fff;

      > p {
        font-size: 15px;
        line-height: 150%;
      }
      .time {
        margin-top: 15px;
        font-size: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .item + .item {
      margin-top: 10px;
    }
  }
  .nothing {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    img {
      width: 60%;
    }
    span {
      font-size: 16px;
      color: #999;
    }
  }
  .btn_sty {
    height: 45px;
    font-weight: 500;
    font-size: 15px;
    color: #ffffff;
    font-family: "PingFangSC-Medium";
    text-align: center;
    line-height: 45px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
  }
}
</style>
